import React from "react";
import { Tilt } from "../styles/HomeStyles";
import { options } from "../data/TiltOptions";
import {
  BlueCardStyle,
  WhiteCardStyle,
  NoShadowCard,
} from "../styles/HomeStyles";

const SvgCard = ({ src, color = "none" }) => {
  return (
    <Tilt
      style={{
        transformStyle: "preserve-3d",
      }}
      options={options}
    >
      {color === "blue" ? (
        <BlueCardStyle>
          <img src={src} alt="card" />
        </BlueCardStyle>
      ) : color === "white" ? (
        <WhiteCardStyle>
          <img src={src} alt="card" />
        </WhiteCardStyle>
      ) : (
        <NoShadowCard>
          <img src={src} alt="card" />
        </NoShadowCard>
      )}
    </Tilt>
  );
};

export default SvgCard;
